"use client";

import { ThemeWrapper } from "app/ThemeWrapper";
import { useTheme } from "styled-components";

function ThemedFavicon() {
  // FIXME: not always working
  const theme = useTheme();

  return (
    <>
      <link rel="shortcut icon" href="/favicon/favicon.ico" />
      <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href="/favicon/favicon-16x16.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href="/favicon/favicon-32x32.png"
      />
      {/* <link
        rel="icon"
        type="image/png"
        sizes="48x48"
        href="/favicon/favicon-48x48.png"
      /> */}
      <link rel="manifest" href="/manifest.json" />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="theme-color" content={theme.theme.background} />
      <meta name="application-name" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta
        name="apple-mobile-web-app-status-bar-style"
        content="black-translucent"
      />
      <meta name="apple-mobile-web-app-title" />
      <link
        rel="apple-touch-startup-image"
        media="(device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"
        href="/favicon/apple-touch-startup-image-640x1136.png"
      />
    </>
  );
}

export default function Favicon() {
  return (
    <ThemeWrapper>
      <ThemedFavicon />
    </ThemeWrapper>
  );
}
